import * as React from "react";
import { IDefaultViewProps } from "./IDefaultViewProps";
import { Caption } from "../../atoms/views/Caption";
import { ContactpersoonIcon } from "../../atoms/icons/ContactpersoonIcon";

// All the incoming values
interface IProps {

}

// Outgoing functions
interface IDispatch {

}

// Actual Component
export type AllProps = IProps & IDispatch & IDefaultViewProps<string | null>;
export const Contactpersoon = (props: AllProps) => {
    const label = props.label || "Contactpersoon";
    return (<Caption {...props} caption={label} icon={<ContactpersoonIcon />}>
        {props.value}
    </Caption>)
}
